import React, { useState } from 'react'
import useTranslation from '../../../i18n/useTranslation'
import { RadioSelector } from '@Knowledge-OTP/znk-ui-components'
import moment from 'moment-timezone'
import FilterBadge from '../../../common/FilterBadge'
const TestDateFilter = (props) => {
  const { translate } = useTranslation()
  const { testDate, setTestDate, testDates: { allActivities: testDates }, serviceFilters } = props
  const [servicesCache, setServicesCache] = useState(null)
  if (serviceFilters !== servicesCache) {
    setServicesCache(serviceFilters)
    setTestDate({
      id: '',
      name: '-',
      date: null
    })
  }
  const submit = (testId) => {
    const thisTest = testDates.find(test => test.id === testId)
    setTestDate({ id: testId, name: thisTest.name, date: thisTest.startDate })
  }
  const selectorData = testDates
    .map((item) => ({ name: item.name, id: item.id }))
    .sort((a, b) => moment(a.startDate).valueOf() - moment(b.startDate).valueOf())
  return (
    <RadioSelector
      direction='down'
      setSelected={submit}
      selected={testDate}
      data={selectorData}
      typeFilter='testDateSelector'
      strings={{
        title: translate('filters.plans.selectTestDate'),
        buttonCancel: translate('filters.plans.buttonCancel'),
        buttonApply: translate('filters.plans.buttonApply'),
        search: translate('filters.plans.search'),
        changingTo: translate('filters.plans.changingTo')
      }}
    >
      <FilterBadge
        title={translate('plans.testDate')}
        options={selectorData}
        selectedIds={testDate?.id ? [testDate.id] : []}
        onClearFilters={() => setTestDate({ id: '', name: '-', date: null })}
      />
    </RadioSelector>
  )
}

export default TestDateFilter
